import React from "react";
import { DialogContentText, Grid, Typography } from "@material-ui/core";
import styled from "styled-components";
import Theme from "../Theme";

const ErrorLabel = styled(Typography)`
  width: 700px;
  color: red;
`;

export function processErrors(error: any) {
  let err;

  try {
    err = JSON.parse(error);
  } catch {
    err = error;
  } finally {
    if (err["errors"] && err["errors"].length) {
      return err["errors"];
    } else if (err["Error"] && err["Error"]["Summary"]) {
      return [err["Error"]["Summary"]];
    } else {
      return [err.toString()];
    }
  }
}

export function getErrorsGrid(errors: string[]) {
  return (
    <Grid item container direction="row" alignItems="flex-start" spacing={2}>
      {" "}
      {errors.map(err => (
        <Grid item key={err}>
          <ErrorLabel variant="subtitle2">{err}</ErrorLabel>
        </Grid>
      ))}
    </Grid>
  );
}

export const DialogContentErrorText = styled(DialogContentText)`
  color: ${Theme.colors.error};
  white-space: pre-line;
`;

export const DialogContentSuccessText = styled(DialogContentText)`
  color: ${Theme.colors.success};
  white-space: pre-line;
`;
